module.exports = __webpack_public_path__ + "static/media/OpenSans.5a798cda.ttf";